import React from "react";
import "./style.scss";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { LinksNetwork } from "../../../pages/Notification/LinksNetwork";

const footerData = {
  en: {
    copyrights: `Copyrights © 2009-${new Date()
      .getFullYear()
      .toString()} ItFox`,
    name: "ITFOX",
    inn: "TIN 2367016947 ",
    okved: "OKVED: 62.01",
    type: "Type of IT activity: 1.01",
    address:
      "For correspondence: 7 Lesnaya Street, Apt. 1/A, Adler District, Sochi, Russia",
    privacy: "Privacy policy",
    main: "Main",
    cases: "Cases",
  },
  ru: {
    copyrights: `Авторское право © 2009-${new Date()
      .getFullYear()
      .toString()} ItFox. Все права защищены.`,
    name: 'ООО "АЙТИФОКС"',
    inn: "ИНН 2367016947 ",
    okved: "ОКВЭД: 62.01",
    type: "Вид деятельности в области ИТ: 1.01",
    address:
      "Для корреспонденции: г. Сочи, р-н Адлерский, Лесная ул, д. 7, 1/а",
    privacy: "Политика конфиденциальности",
    main: "Главная",
    cases: "Кейсы",
  },
};

export const Footer = ({ lang, page }) => {
  return (
    <footer className="footer">
      <section
        className={`base-section ${page === "main" ? "section__margin" : ""}`}
      >
        <div className="container">
          <div className="wrapper-logo">
            <div>
              <img
                className="brand-logo"
                src="/img/ITWEBFOX WHITE_TXT2FIX_NEW.svg"
                alt="brand-logo"
              />
              {/* <div className="heading">{footerData[lang].text}</div> */}
            </div>
            <a
              target="_blank"
              href="https://arda.digital/ "
              aria-label="ARDA"
              rel="noopener noreferrer"
              // onMouseOver={() => setIsHover(true)}
              // onMouseLeave={() => setIsHover(false)}
              className="arda-logo"
            >
              <img width="60" height="60" src={`/img/arda.svg`} alt="" />
            </a>
          </div>
          <div className="wrapper-info">
            <div className="item-info">
              <div className="item-legal">
                <div className="info">{footerData[lang].name}</div>
                <div className="flex">
                  <div className="info">{footerData[lang].inn}</div>
                  <div className="info">{footerData[lang].okved}</div>
                </div>

                <div className="info">{footerData[lang].type}</div>
                <div className="info">{footerData[lang].address}</div>
              </div>

              {/* <LinksNetwork color="#141414" bg="#fff" /> */}
              <Link
                // target="_blank"
                to={`/privacy-policy/${lang}`}
                className="link policy"
              >
                {footerData[lang].privacy}
              </Link>
              <div className="copyrights">{footerData[lang].copyrights}</div>
            </div>
            <div className="item-info">
              <Link to={`/main/${lang}`} className="link">
                {footerData[lang].main}
              </Link>
              <Link to={`/portfolio/${lang}`} className="link">
                {footerData[lang].cases}
              </Link>
              <a href="tel:+79288542462" className="link">
                +7 (928) 854-24-62
              </a>
              <a href="mailto:hello@itfox-web.com" className="link">
                hello@itfox-web.com
              </a>
              <LinksNetwork color="#141414" bg="#fff" />
            </div>
          </div>
        </div>
      </section>
    </footer>
  );
};
